'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * A regular action-button, but with the option of having a tooltip and a built-in
 * icon.
 */
var ActionButton = function (_React$Component) {
	_inherits(ActionButton, _React$Component);

	function ActionButton() {
		_classCallCheck(this, ActionButton);

		return _possibleConstructorReturn(this, (ActionButton.__proto__ || Object.getPrototypeOf(ActionButton)).apply(this, arguments));
	}

	_createClass(ActionButton, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    className = _props.className,
			    tooltip = _props.tooltip,
			    disabled = _props.disabled,
			    large = _props.large,
			    children = _props.children,
			    icon = _props.icon,
			    popoverMenu = _props.popoverMenu,
			    other = _objectWithoutProperties(_props, ['className', 'tooltip', 'disabled', 'large', 'children', 'icon', 'popoverMenu']);

			var classes = (0, _classnames2.default)(className, 'action-button', { disabled: disabled, 'btn-lg': large });
			var result = _react2.default.createElement(
				_reactBootstrap.Button,
				_extends({}, other, { className: classes, disabled: disabled, alt: tooltip }),
				icon && _react2.default.createElement('span', { className: 'gg icon-GG-' + icon }),
				children
			);

			// Provide a tooltip with an overlay trigger
			if (tooltip && !disabled) {
				var tooltipComponent = _react2.default.createElement(
					_reactBootstrap.Tooltip,
					{ id: 'tooltip' },
					tooltip
				);
				result = _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{ placement: 'top', overlay: tooltipComponent },
					result
				);
			}

			// Decorate with another overlay trigger to allow a popup menu to appear when
			// clicked.
			if (popoverMenu) {
				var Overlay = popoverMenu;
				// Accept raw elements as well as render functions (react classes and the like)
				// OverlayTrigger requires an Element.
				if (typeof popoverMenu === 'function') {
					Overlay = _react2.default.createElement(Overlay, null);
				}
				result = _react2.default.createElement(
					_reactBootstrap.OverlayTrigger,
					{
						placement: 'bottom',
						trigger: 'click',
						rootClose: true,
						overlay: Overlay
					},
					result
				);
			}
			return result;
		}
	}]);

	return ActionButton;
}(_react2.default.Component);

ActionButton.propTypes = _extends({}, _reactBootstrap.Button.propTypes, {
	disabled: _propTypes2.default.bool,
	tooltip: _propTypes2.default.string,
	icon: _propTypes2.default.string,
	popoverMenu: _propTypes2.default.oneOfType([
	/*
 * This is a render function. It must return a React Element, specifically an
 * element acceptable by OverlayTrigger (Tooltip, Popover, etc.)
 */
	_propTypes2.default.func, _propTypes2.default.node]),
	// Enlarges the button (applies .btn-lg).
	large: _propTypes2.default.bool
});

/*
 * Component wrapper for an .action-bar
 */
var ActionBar = function ActionBar(_ref) {
	var children = _ref.children,
	    grouped = _ref.grouped,
	    disabled = _ref.disabled,
	    large = _ref.large;

	var newChildren = _react2.default.Children.map(children, function (child) {
		// Allow the disabling of all child buttons at once
		if (child.type === ActionButton) {
			return _react2.default.cloneElement(child, { disabled: disabled, large: large });
		}
		return child;
	});

	// 'grouped' is a special type of action bar for page headers.
	var classes = (0, _classnames2.default)('action-bar', { 'grouped-actions': grouped });
	return _react2.default.createElement(
		'div',
		{ className: classes },
		newChildren
	);
};

ActionBar.propTypes = {
	// Use to disable all action buttons at once.
	disabled: _propTypes2.default.bool,
	// A style change that looks similar to a Bootstrap button-group. Designed for PageHeaders.
	grouped: _propTypes2.default.bool,
	// Enlarges each button in the action bar.
	large: _propTypes2.default.bool
};

ActionBar.Button = ActionButton;
var _default = ActionBar;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(ActionButton, 'ActionButton', 'src/components/ActionBar.jsx');

	__REACT_HOT_LOADER__.register(ActionBar, 'ActionBar', 'src/components/ActionBar.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/ActionBar.jsx');
}();

;